import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import FeedView from './FeedView';
import Home from './Home';

function ConditionalHome() {
    const { user, loading } = useAuth();

    if (loading) return <div>Loading...</div>;

    return user ? <FeedView /> : <Home />;
}

export default ConditionalHome;
